import React, { Component } from 'react';
import { connect, } from 'react-redux';
import { Container, Spinner, Row } from 'react-bootstrap';
import { withRouter } from '../withRouter';
import { Howl, Howler } from "howler";
import { createRoom, reconnectToRoom, joinAsMirror, reconnectAsMirror, loadMirrorReconnect, } from 'actions/room';
import { sessionEnded } from 'actions/auth';


import { getPlayableGames, getGameList, refreshGames as refreshCatalog, enrichAddonWithParentMeta } from "constants/GameListAdapter";
import AuthService from 'services/auth';

import styles from './LobbyStyles.module.scss';
import formStyles from "components/Forms/FormStyles.module.scss";
import DotLoader from 'components/Utlility/DotLoader';
import PageSEO from 'components/Utlility/PageSEO';
import { SEO_CONFIG } from 'constants/SeoConfig';

import Game from "components/Games/Game";
import GameMenu from "./GameMenu";
import FormPage from '../Forms/FormPage';
import BuyForLobbyModal from 'components/BuyForLobbyModal/BuyForLobbyModal';
import ConnectCard from './ConnectCard';
import { CONNECT_ENABLED } from 'constants/FeatureFlags';

import lobbyBgMusic from "audio/lobby-bg-music.mp3";
import joinedSFX from "audio/player-joined.wav";
import disconnectingSFX from "audio/disconnecting.wav";
import disconnectedSFX from "audio/disconnected.wav";
import hoverOrClickSFX from "audio/hover-click.mp3";
import newGameSFX from "audio/new-game.wav";
import errorSFX from "audio/error.wav";
import ErrorModal from '../Utlility/ErrorModal';
import { RoomErrorCodes, isTerminalRoomError } from 'constants/ErrorCodes';

import muteButton from "images/icons/lobby_unmuted.png"
import mutedButton from "images/icons/lobby_muted.png"
import fullscreenButton from "images/icons/lobby_fullscreen.png"
import { APP_TYPES } from 'constants/AppTypes';
import { postCapabilitiesOncePerDevice } from "telemetry/capabilitiesPostOnce.ts";

const fullscreenAvailable = document.fullscreenEnabled || document.mozFullscreenEnabled || document.webkitFullscreenEnabled ? true : false;
var unBindPlayerJoindMessage = null;
var unBindPlayerLeaveMessage = null;
var unBindRefreshLobbyGamesMessage = null;

var audio = {
    lobbyBg: {
        import: lobbyBgMusic,
        loaded: null,
        volume: 0.15,
        loop: true,
    },
    joined: {
        import: joinedSFX,
        loaded: null,
        volume: 1,
        loop: false,
    },
    disconnecting: {
        import: disconnectingSFX,
        loaded: null,
        volume: 1,
        loop: false,
    },
    disconnected: {
        import: disconnectedSFX,
        loaded: null,
        volume: 1,
        loop: false,
    },
    hoverOrClick: {
        import: hoverOrClickSFX,
        loaded: null,
        volume: 0.35,
        loop: false,
    },
    newGame: {
        import: newGameSFX,
        loaded: null,
        volume: 1,
        loop: false,
    },
    error: {
        import: errorSFX,
        loaded: null,
        volume: 1,
        loop: false,
    }
};

class Lobby extends Component {
    static displayName = Lobby.name;

    constructor(props) {
        super(props);

        this.state = {
            connected: false,
            userGames: [],
            userAddons: [],
            freeGames: [],
            loadingGames: true,
            gamesLoadFailed: false,
            catalogLoadFailed: false,
            roomError: false,
            errorMessage: "",
            selectedGame: null,
            notifications: [],
            roomLoadingTitle: "",
            acceptedScreenSizeWarning: false,
            muted: false,
        };
    }


    componentDidMount() {
        const queryParams = new URLSearchParams(window.location.search);

        // Handle server close codes (e.g., 4200 = session ended)
        const closeCode = queryParams.get("code");
        if (closeCode === "4200") {
            this.props.navigate(window.location.pathname, { replace: true });
            this.props.sessionEnded("Your game was ended because your session expired or was ended on another device.");
            return;
        }

        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        if (this.props.room.roomOpen && !this.props.room.isHost) {
            if (queryParams.has("roku")) {
                return setTimeout(() => this.props.navigate(`/play?roku`));
            } else {
                return setTimeout(() => this.props.navigate(`/play`));
            }
        }

        // Mirror hosts don't need to be logged in — they joined via /mirror
        if (this.props.room.isMirror && this.props.room.roomOpen) {
            this.setState({ notifications: [], loadingGames: false });
            this.initAudio();
            this.setRoomListeners();
            this.updateMirrorUrl();
            return;
        }

        // Mirror reconnect: if URL has ?mirror=ROOMCODE, rejoin as mirror.
        // Token sources in priority order:
        //   1. URL ?token=  (set by joinAsMirror/reconnectAsMirror or by an
        //      external game's change_game redirect)
        //   2. localStorage entry matching this roomCode — fallback when the
        //      URL token has been stripped (SPA nav, autofill, etc.)
        // If no token from either source, falls through to fresh joinAsMirror.
        if (queryParams.has("mirror")) {
            const mirrorRoomCode = queryParams.get("mirror");
            let mirrorToken = queryParams.get("token");
            if (!mirrorToken) {
                const stored = loadMirrorReconnect(mirrorRoomCode);
                if (stored) {
                    mirrorToken = stored.reconnectionToken;
                    console.log("[Lobby] Mirror reconnect using stored token from localStorage");
                }
            }
            console.log("[Lobby] Mirror reconnect for room:", mirrorRoomCode, "token:", mirrorToken ? "present" : "none");
            this.setState({ roomLoadingTitle: "Reconnecting mirror..." });
            this.doMirrorJoin(mirrorRoomCode, mirrorToken);
            return;
        }

        if (this.props.auth.isLoggedIn) { // user logged in?
            if (this.props.room.roomOpen === false) { // room already open?
                if (queryParams.has("token")) { // is attempting reconnect?
                    // Use server-side check for external game context
                    this.doReconnectWithServerCheck(queryParams.get("token"));
                } else {
                    console.log("Creating Room...");
                    const QRSessionID = queryParams.get("QRSessionID");
                    // Get requested room code and host token if returning from external game (e.g., Tenable, SongBlast)
                    const requestedRoomCode = queryParams.get("createRoom");
                    const externalGameToken = queryParams.get("hostToken");
                    console.log("QRsession: " + QRSessionID);
                    if (requestedRoomCode) {
                        console.log("Requested room code: " + requestedRoomCode);
                    }
                    if (externalGameToken) {
                        console.log("External game token present for host verification");
                    }
                    this.doCreate(QRSessionID, requestedRoomCode, externalGameToken);
                }
            } else {
                if (this.props.room.isHost) { // are they the host?
                    this.setState({ notifications: [] });
                    if (!this.props.room.isMirror) {
                        this.getUserGames();
                    } else {
                        this.setState({ loadingGames: false });
                    }
                    this.initAudio();
                    if (!this.props.room.isMirror) {
                        this.updateToken(this.props.room.room.reconnectionToken);
                    }

                    this.setRoomListeners();
                } else {
                    return setTimeout(() => this.props.navigate("/join"));
                }
            }
        }
    }

    componentWillUnmount() {
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        Howler.stop();
        this.removeRoomListeners();
    }

    handleVisibilityChange = () => {
        if (document.hidden && Howler) {
            Howler.mute(true);
        } else if (!document.hidden && Howler) {
            Howler.mute(this.state.muted);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.room.roomOpen === true && prevProps.room.roomOpen === false) {
            this.setRoomListeners();
        } else if (this.props.room.roomOpen === false && prevProps.room.roomOpen === true) {
            if (this.props.room.startingGame !== true) {
                const code = this.props.room.errorCode;
                // If this was a mirror terminally cut by the host (Connect
                // disabled, removed, session full, previously kicked), send
                // them straight back to the Connect form with the reason
                // surfaced there. The lobby is a transient mirroring
                // surface — no value in showing an error here that the
                // user can't act on without leaving the page anyway.
                if (prevProps.room.isMirror && isTerminalRoomError(code)) {
                    this.props.navigate(`/connect?error=${code}`, { replace: true });
                    return;
                }
                this.playAudio(audio.error.loaded);
                Howler.stop();
                // Clear local errorMessage so getUserFriendlyRoomError() resolves
                // a code-specific message from RoomErrorCodes (e.g. "Host stopped
                // Connect", "Host removed you"). The previous hardcoded fallback
                // overrode every distinct reason with one generic line.
                this.setState({ roomError: true, errorMessage: "" });
            }
        }

        if (this.props.room.startingGame === true && prevProps.room.startingGame === false) {
            this.playAudio(audio.newGame.loaded);
        }
    }

    initAudio() {
        this.preloadAudio();
        Howler.volume(0.5);
        // Only play if not already playing
        if (audio.lobbyBg.loaded && !audio.lobbyBg.loaded.playing()) {
            this.playAudio(audio.lobbyBg.loaded, true, 0.05);
        }
    }

    preloadAudio() {
        for (let key in audio) {
            if (audio[key].loaded) continue;
            audio[key].loaded = new Howl({
                src: [audio[key].import],
                preload: true,
                loop: audio[key].loop,
                volume: audio[key].volume
            });
        }
    }

    playAudio(audio) {
        if (audio) audio.play();
    }

    toggleFullScreen = () => {
        if (fullscreenAvailable) {
            if (!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
                let elem = document.documentElement
                if (elem.requestFullscreen) {
                    elem.requestFullscreen();
                } else if (elem.webkitRequestFullscreen) {
                    elem.webkitRequestFullscreen();
                } else if (elem.mozRequestFullScreen) {
                    elem.mozRequestFullScreen();
                } else if (elem.msRequestFullscreen) {
                    elem.msRequestFullscreen();
                }
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                } else if (document.mozExitFullscreen) {
                    document.mozExitFullscreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            }
        }
    }

    doCreate(QRSessionID = null, roomCode = null, externalGameToken = null) {
        this.setState({ roomError: false, errorMessage: "", roomLoadingTitle: "Creating your room", })
        console.log("Calling create room with session: " + QRSessionID + " roomCode: " + roomCode)
        this.props.createRoom(this.props.auth.user.token, this.props.auth.user.id, false, QRSessionID, roomCode, externalGameToken).then((res) => {
            if (res.Status === "Error") {
                Howler.stop();
                this.setState({ roomError: true, errorMessage: res.Message, });

            } else if (res.Status === "Success") {
                this.setState({ notifications: [] });
                this.getUserGames();
                this.initAudio();
            }
        });
    }

    /**
     * Extract room code from V3 token format: roomCode:sessionId-V3
     */
    extractRoomCodeFromToken(token) {
        if (!token || !token.includes('-V3')) return null;

        const parts = token.split(':');
        return parts[0] || null;
    }

    /**
     * Check room status with GamesServer
     * Returns { gameExists, isExternal, gameId, serverUrl, hostToken } if external
     */
    async checkRoomStatus(roomCode) {
        try {
            // Convert WebSocket URL to HTTP for fetch
            const wsUrl = process.env.REACT_APP_GAME_SERVER_URL || '';
            const httpUrl = wsUrl.replace('wss://', 'https://').replace('ws://', 'http://');
            const response = await fetch(`${httpUrl}/game-exists?roomId=${roomCode}&sessionId=`);

            if (!response.ok) {
                console.log("[Lobby] Room status check failed:", response.status);
                return { gameExists: false };
            }

            return await response.json();
        } catch (e) {
            console.warn("[Lobby] Failed to check room status:", e);
            return { gameExists: false };
        }
    }

    /**
     * Notify external game that host has returned to lobby.
     * This tells the external game to immediately send players back.
     */
    async notifyExternalGameHostReturned(serverUrl, roomCode, newRoomCode) {
        try {
            // Convert WebSocket URL to HTTP for the API call
            const httpUrl = serverUrl.replace('ws://', 'http://').replace('wss://', 'https://');

            const response = await fetch(`${httpUrl}/api/host-returned-to-lobby/${roomCode}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ lobbyCode: newRoomCode }),
            });

            if (response.ok) {
                console.log("[Lobby] Notified external game of host return");
            } else {
                console.log("[Lobby] External game notification failed (may have already closed):", response.status);
            }
        } catch (e) {
            // Ignore errors - external game may have already closed via 5-sec timer
            console.log("[Lobby] Failed to notify external game (may have already closed):", e.message);
        }
    }

    /**
     * Main reconnection flow with server-side external game detection.
     * Token format V3: roomCode:sessionId-V3
     */
    async doReconnectWithServerCheck(token) {
        this.setState({ roomError: false, errorMessage: "", roomLoadingTitle: "Reconnecting to your room", });

        // Extract room code from token
        const roomCode = this.extractRoomCodeFromToken(token);

        if (!roomCode) {
            // Legacy token without room code - just try normal reconnect
            console.log("[Lobby] Legacy token format, attempting normal reconnect");
            this.doReconnect(token);
            return;
        }

        // Check server for room status
        // This tells us if the room code is reserved for an external game and gives us the hostToken
        console.log("[Lobby] Checking room status for:", roomCode);
        const roomStatus = await this.checkRoomStatus(roomCode);

        if (roomStatus.isExternal) {
            console.log("[Lobby] Room code reserved for external game:", roomStatus.gameId);
            // Don't redirect host back to external game - they want to return to lobby
            // The hostToken from roomStatus will be used to reclaim the room code
        }

        // Try reconnection (will fail if old room disposed), then create new room
        this.doReconnect(token, roomCode, roomStatus);
    }

    /**
     * Attempt reconnection to existing room, with fallback to create new room.
     * If roomStatus indicates the code was recently at an external game, notify it.
     */
    doReconnect(token, roomCode = null, roomStatus = null) {
        this.setState({ roomError: false, errorMessage: "", roomLoadingTitle: "Reconnecting to your room", })
        setTimeout(() => {
            this.props.reconnectToRoom(token).then(async (res) => {
                if (res.Status === "Error") {
                    // Reconnection failed - create new room
                    console.log("[Lobby] Reconnection failed, creating new room");

                    // If we have external game context, use hostToken to reclaim code
                    if (roomStatus && roomStatus.hostToken && roomCode) {
                        console.log("[Lobby] Using hostToken to reclaim room code:", roomCode);
                        this.doCreate(null, roomCode, roomStatus.hostToken);

                        // Notify external game to send players immediately (fire and forget)
                        if (roomStatus.serverUrl) {
                            this.notifyExternalGameHostReturned(roomStatus.serverUrl, roomCode, roomCode);
                        }
                    } else {
                        // No external context - just create new room with new code
                        this.doCreate();
                    }
                } else if (res.Status === "Success") {
                    this.setState({ notifications: [] });
                    this.getUserGames();
                    this.initAudio();
                }
            });
        }, 1500);
    }

    doMirrorJoin(roomCode, token = null) {
        const loadingTitle = token ? "Reconnecting..." : "Connecting...";
        this.setState({ roomError: false, errorMessage: "", roomLoadingTitle: loadingTitle, mirrorRoomCode: roomCode });

        if (token) {
            // Reconnect into existing session (preserves slot, avoids duplicate mirror entries)
            this.props.reconnectAsMirror(token).then((res) => {
                if (res.Status === "Error") {
                    // Reconnect failed (token expired / session gone) — fall back to fresh join
                    console.log("[Lobby] Mirror reconnect failed, trying fresh join");
                    this.doMirrorJoin(roomCode);
                    return;
                }
                this.setState({ notifications: [], loadingGames: false });
                this.initAudio();
                this.updateMirrorUrl(roomCode);
            });
        } else {
            // Fresh mirror join (first time, or reconnect token unavailable).
            // Retry with backoff: when returning from an external game both the
            // primary host (?createRoom=ABCD) and the mirror (?mirror=ABCD)
            // land here simultaneously. The mirror's joinById fails until the
            // primary host has finished creating the new lobby room — same
            // race we handle in the external games' join flow.
            this.attemptMirrorJoinWithRetry(roomCode);
        }
    }

    attemptMirrorJoinWithRetry = async (roomCode, maxAttempts = 60, delayMs = 1000) => {
        let lastResult = null;
        for (let attempt = 1; attempt <= maxAttempts; attempt++) {
            const res = await this.props.joinAsMirror(roomCode);
            lastResult = res;
            if (res?.Status === "Success") {
                this.setState({ notifications: [], loadingGames: false });
                this.initAudio();
                this.updateMirrorUrl(roomCode);
                return;
            }
            console.warn(`[Lobby] Mirror join attempt ${attempt}/${maxAttempts} failed:`, res?.Message);
            if (attempt < maxAttempts) {
                await new Promise((resolve) => setTimeout(resolve, delayMs));
            }
        }
        console.error("[Lobby] Mirror join failed after retries:", lastResult?.Message);
        this.props.navigate("/connect");
    };

    updateMirrorUrl(roomCode) {
        const code = roomCode || this.props.room.roomId;
        // Persist the reconnection token in the URL so a refresh lands back
        // in the same mirror slot. URL is the primary source — localStorage
        // is a fallback handled at mount.
        const token = this.props.room.room?.reconnectionToken;
        try {
            const url = new URL(window.location.href);
            const params = new URLSearchParams();
            params.set("mirror", code);
            if (token) params.set("token", token);
            window.history.replaceState(null, null, `${url.pathname}?${params.toString()}`);
        } catch (e) {
            console.warn(e);
        }
    }

    async getUserGames() {
        // Retry on transient failures. Most "empty lobby after login" reports trace
        // back to a single BPG API blip — a one-shot fetch with no retry leaves the
        // host stuck on "Select a Game" with nothing. 3 attempts with backoff
        // covers the common transient case; the gamesLoadFailed flag surfaces a
        // genuine outage to the UI so the host has a way out.
        const BACKOFFS_MS = [0, 1500, 3000]; // delay BEFORE each attempt
        const MAX_ATTEMPTS = BACKOFFS_MS.length;

        this.setState({ loadingGames: true, gamesLoadFailed: false });

        let lastError = null;
        for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt++) {
            if (BACKOFFS_MS[attempt] > 0) {
                await new Promise(r => setTimeout(r, BACKOFFS_MS[attempt]));
            }
            try {
                const response = await AuthService.getGames(this.props.auth.user.email);
                console.log("Response from getGames:", response);
                if (!response || !response.games) {
                    throw new Error("response missing games array");
                }

                const gameIds = response.games.map(x => x.code);
                const addonsIds = (response.addons || []).map(x => x.code);
                const freeGameIds = (response.freeGames || []).map(x => x.code);
                const availableGames = [...new Set([...gameIds, ...freeGameIds])];

                this.setState({
                    userGames: response.games,
                    userAddons: response.addons || [],
                    freeGames: response.freeGames || [],
                    loadingGames: false,
                    gamesLoadFailed: false,
                });

                this.props.room?.room?.send("update_available_games", { games: availableGames, addons: addonsIds });
                this.props.room?.room?.send("update_pin", { pin: response.roomPin });

                // The user's games came back fine, but if the boot-time CMS
                // catalog fetch failed (cache is empty) the lobby would still
                // render nothing because getOwnedGames() intersects owned IDs
                // against an empty catalog. Re-pull the catalog in the
                // background so the host doesn't sit on a stale empty cache.
                if (getPlayableGames().length === 0) {
                    this.ensureCatalogLoaded();
                }
                return;
            } catch (err) {
                lastError = err;
                console.log(`[Lobby] getUserGames attempt ${attempt + 1}/${MAX_ATTEMPTS} failed:`, err?.message || err);
            }
        }

        // All retries exhausted — surface the failure so the UI can offer a manual retry
        console.error("[Lobby] getUserGames exhausted retries:", lastError?.message || lastError);
        this.setState({ loadingGames: false, gamesLoadFailed: true });
    }

    async ensureCatalogLoaded() {
        // GameListAdapter already retries internally (3 attempts with backoff),
        // so one call here covers transient CMS blips. If it still comes back
        // empty, surface catalogLoadFailed so the render can offer a manual
        // retry rather than silently showing a games-less lobby.
        this.setState({ catalogLoadFailed: false });
        try {
            const catalog = await refreshCatalog(this.props.pricing?.countryCode);
            if (!catalog || catalog.length === 0) {
                this.setState({ catalogLoadFailed: true });
            } else {
                // Force a re-render so getOwnedGames sees the freshly-cached list.
                this.forceUpdate();
            }
        } catch (err) {
            console.error("[Lobby] ensureCatalogLoaded failed:", err?.message || err);
            this.setState({ catalogLoadFailed: true });
        }
    }

    retryGameFetches = async () => {
        await this.ensureCatalogLoaded();
        this.getUserGames();
    }

    setRoomListeners() {
        if (!this.props.room.isMirror) {
            this.updateToken(this.props.room.room.reconnectionToken);
        }
        postCapabilitiesOncePerDevice();

        if (unBindPlayerJoindMessage) unBindPlayerJoindMessage()
        unBindPlayerJoindMessage = this.props.room.room.onMessage("player_joined", (message) => {
            console.log("player_joined", "received on", this.props.room.room.name, message);
            this.playAudio(audio.joined.loaded);
            this.doNotification(`${message.player.name} has joined!`);
        });

        if (unBindPlayerLeaveMessage) unBindPlayerLeaveMessage()
        unBindPlayerLeaveMessage = this.props.room.room.onMessage("player_leave", (message) => {
            console.log("player_leave", "received on", this.props.room.room.name, message);
            this.playAudio(audio.disconnected.loaded);
            this.doNotification(`${message.player.name} has left!`);
        });

        if (unBindRefreshLobbyGamesMessage) unBindRefreshLobbyGamesMessage()
        unBindRefreshLobbyGamesMessage = this.props.room.room.onMessage("refresh_lobby_games", (message) => {
            console.log("refresh_lobby_games", "received on", this.props.room.room.name);
            this.getUserGames();
        });

    }

    removeRoomListeners() {
        if (unBindPlayerJoindMessage) unBindPlayerJoindMessage()
        if (unBindPlayerLeaveMessage) unBindPlayerLeaveMessage()
        if (unBindRefreshLobbyGamesMessage) unBindRefreshLobbyGamesMessage()
    }

    doNotification(text) {
        this.setState((prevState) => {
            return { notifications: [...prevState.notifications, text] }
        });
        setTimeout(() => {
            this.setState((prevState) => {
                prevState.notifications.shift();
                return { notifications: prevState.notifications }
            });
        }, 5000);
    }

    getOwnedGames() {
        let ownedGameList = [];
        let freeGameList = [];

        if (this.props.room.isMirror) {
            // Mirror mode: derive game list from room state's availableGames (synced from primary host)
            const availableGameIds = this.props.room.roomState?.availableGames || [];
            getPlayableGames().filter(g => g.status !== 'disabled').forEach((x) => {
                if (availableGameIds.includes(x.gameId)) {
                    ownedGameList.push(x);
                }
            });
        } else {
            let userGames = [...this.state.userGames];
            let freeGames = [...this.state.freeGames];

            // Use playable games list (individual games from Games table, not products/bundles)
            getPlayableGames().filter(g => g.status !== 'disabled').forEach((x) => {
                if (userGames.findIndex((y) => y.code === x.gameId) > -1) {
                    ownedGameList.push(x);
                } else if (freeGames.findIndex((y) => y.code === x.gameId) > -1) {
                    freeGameList.push(x);
                }
            });
        }

        return <ul className={styles.games}>
            {CONNECT_ENABLED && !this.props.room.isMirror && <ConnectCard
                mirrorCount={this.props.room.roomState?.mirrorCount || 0}
                connectEnabled={this.props.room.roomState?.connectEnabled !== false}
                mirrors={this.props.room.roomState?.mirrors}
                room={this.props.room.room}
            />}
            {ownedGameList.map(g => {
                const gameVotes = this.props.room.players.filter((player) => player.gameVote === g.gameId).length;
                return <li className={styles.game} key={g.gameId}>
                    <Game game={g} fromLobby={true} loadGameMenu={this.loadGameMenu} gameVotes={gameVotes} addons={this.state.userAddons} supported={true} />
                </li>
            })}
            {freeGameList.map(g => {
                const gameVotes = this.props.room.players.filter((player) => player.gameVote === g.gameId).length;
                return <li className={styles.game} key={`free-${g.gameId}`}>
                    <Game game={g} fromLobby={true} loadGameMenu={this.loadGameMenu} gameVotes={gameVotes} addons={this.state.userAddons} supported={true} />
                </li>
            })}
        </ul>
    }

    isDev() { return !process.env.REACT_APP_ENVIRONMENT || process.env.REACT_APP_ENVIRONMENT === 'development' }

    getUnownedProducts() {
        const ownedCodes = new Set(
            [...this.state.userGames, ...this.state.freeGames].map(g => g.code)
        );

        // Get enabled products (type Game) that grant access to at least one
        // enabled game the user doesn't already own
        const playableGames = getPlayableGames();
        const allProducts = getGameList();
        return allProducts.filter(product => {
            if (product.status === 'disabled') return false;
            if (product.status === 'hidden' && !this.isDev()) return false;
            if (product.type !== 'Game') return false;
            if (product.tags?.includes('is-pack')) return false; // TODO: temp fix until new Brain Games version

            const grantedGameIds = product.gameIds || [];
            return grantedGameIds.some(gId => {
                if (ownedCodes.has(gId)) return false;
                const game = playableGames.find(g => g.gameId === gId);
                return game && game.status !== 'disabled';
            });
        });
    }

    // Addons the user can buy to extend a game they already own. Only surfaces
    // an addon when its parent game is in the user's library — without the base
    // game the addon content is unusable, so promoting it would be misleading.
    getUnownedAddonsForOwnedGames() {
        const ownedGameCodes = new Set(
            [...this.state.userGames, ...this.state.freeGames].map(g => g.code)
        );
        const ownedAddonCodes = new Set((this.state.userAddons || []).map(a => a.code));
        const allProducts = getGameList();

        // Build addon.gameId -> [parent Game.gameId, ...] from each game's addonIds.
        const parentsByAddonId = new Map();
        allProducts.forEach(p => {
            if (p.type !== 'Game' || !Array.isArray(p.addonIds)) return;
            p.addonIds.forEach(addonId => {
                if (!parentsByAddonId.has(addonId)) parentsByAddonId.set(addonId, []);
                parentsByAddonId.get(addonId).push(p.gameId);
            });
        });

        return allProducts.filter(product => {
            if (product.type !== 'Addon') return false;
            if (product.status === 'disabled') return false;
            if (product.status === 'hidden' && !this.isDev()) return false;
            if (ownedAddonCodes.has(product.gameId)) return false;
            const parents = parentsByAddonId.get(product.gameId) || [];
            return parents.some(parentId => ownedGameCodes.has(parentId));
        });
    }

    loadGameMenu = (game) => {
        if (this.props.room.isMirror) return; // Mirror mode — display only, no interaction

        this.playAudio(audio.hoverOrClick.loaded);
        this.setState({ selectedGame: game });
    }

    closeGameMenu = () => {
        this.playAudio(audio.hoverOrClick.loaded);
        this.setState({ selectedGame: null });
    }

    closeAndLeave = () => {
        if (this.props.room.roomOpen) {
            // Send close_room to permanently close the room, then navigate away.
            // Simply navigating away would leave the room alive with a reconnection window.
            this.props.room.room.send("close_room");
        }
        this.playAudio(audio.hoverOrClick.loaded);
        this.props.navigate("/");
    }

    acceptSmallScreen = () => {
        this.playAudio(audio.hoverOrClick.loaded);
        this.setState({ acceptedScreenSizeWarning: true });
    }

    updateToken(token) {
        var url = new URL(window.location.href);

        try {
            window.history.replaceState(null, null, (url.pathname) + (`?token=${token}`));
        } catch (e) {
            console.warn(e)
        }
    }

    mute = () => {
        this.setState({ muted: !this.state.muted });
        Howler.mute(!this.state.muted);
    }

    getUserFriendlyRoomError = () => {
        let error = RoomErrorCodes[this.props.room.errorCode];
        console.log("error code:", this.props.room.errorCode);
        if (!error) error = RoomErrorCodes.default;
        return error.displayMessage;
    }

    refreshGames = () => {
        this.setState({ refreshingGames: true, refreshCooldown: 10 });
        this.props.room.room.send("refresh_lobby_games", {});

        const cooldown = setInterval(() => {
            const cooldownTime = this.state.refreshCooldown - 1;
            this.setState({ refreshCooldown: cooldownTime });
            if (cooldownTime === 0) {
                this.setState({ refreshingGames: false });
                clearInterval(cooldown);
            }
        }, 1000);
    }

    onPurchased = () => {
        // Don't close the modal here — it stays open on its success state so the
        // user can confirm. The modal calls onClose when they dismiss it.
        // Refresh both server-side room state (availableGames/availableAddons)
        // AND local ownership so getUnownedAddonsForOwnedGames stops surfacing
        // the just-bought addon under "Add More".
        this.refreshGames();
        this.getUserGames();
    }

    onBuyGameForLobby = (product) => {
        // The unowned list now passes product objects directly (not wrapped games)
        this.setState({ BuyForLobbyGame: product });
    }

    // Click handler for addon cards in the lobby quick-buy. Addons have no
    // standalone shop page, so the default storeSlug navigation would dead-end.
    // Owns the parent game → open the BuyForLobbyModal popup (in-lobby checkout).
    // Doesn't own it → send them to the parent's shop page so they can buy both
    // there (where the "Base Game Required" modal handles the bundling).
    onClickAddonInLobby = (addon) => {
        const allProducts = getGameList();
        const parents = allProducts.filter(p =>
            p.type === 'Game' && Array.isArray(p.addonIds) && p.addonIds.includes(addon.gameId)
        );
        const ownedGameCodes = new Set(
            [...this.state.userGames, ...this.state.freeGames].map(g => g.code)
        );
        const ownedParent = parents.find(p => ownedGameCodes.has(p.gameId));
        if (ownedParent) {
            this.onBuyGameForLobby(addon);
            return;
        }
        const fallbackParent = parents[0];
        if (fallbackParent?.storeSlug) {
            this.props.navigate(fallbackParent.storeSlug);
        }
    }

    render() {
        return (
            <React.Fragment>
                <PageSEO {...SEO_CONFIG['/lobby']} />
                <div className={styles.cityScape} />
                <div className={`${styles.gameLobbyBackground} d-none d-md-block`}>

                    <div className={styles.cloudBG} />
                    <div className={styles.settingButtons}>
                        {fullscreenAvailable && <button className={styles.muteButton} onClick={this.toggleFullScreen} >
                            <img src={fullscreenButton} alt="fullscreen-button" />
                        </button>}
                        <button className={styles.muteButton} onClick={this.mute} >
                            <img src={this.state.muted ? mutedButton : muteButton} alt="mute-button" />
                        </button>
                    </div>
                    <div className={styles.gameLobby}>
                        {
                            this.props.room.roomOpen ?
                                <React.Fragment>
                                    {
                                        (this.state.loadingGames || this.props.room.roomState?.isGameListLoading) ?
                                            <div className={styles.loadingBox}>
                                                <h2>Loading your games</h2>
                                                <DotLoader size="large" variant="light" />
                                            </div>
                                            :
                                            <Container fluid>
                                                {this.props.room.isMirror ? (
                                                    <>
                                                        <div className="text-center text-white" style={{ marginBottom: "2vh" }}>
                                                            <h2 className={styles.lobbyTitle}>Let's Play!</h2>
                                                            <span className={styles.connectBadge}>
                                                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                                                    <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
                                                                    <line x1="8" y1="21" x2="16" y2="21" />
                                                                    <line x1="12" y1="17" x2="12" y2="21" />
                                                                </svg>
                                                                Game.City Connect
                                                            </span>
                                                            <p style={{ fontSize: "2.2vh", opacity: 0.8, maxWidth: "900px", margin: "0 auto" }}>
                                                                The game will start when the host or VIP selects a game. Games will launch automatically on this screen.
                                                                If you close this browser window, the controllers will stay connected to the room.
                                                            </p>
                                                        </div>
                                                        {this.getOwnedGames()}
                                                    </>
                                                ) : (
                                                    <>
                                                        {(this.state.gamesLoadFailed || this.state.catalogLoadFailed) ?
                                                            // Fetch failure path — distinct from "no games owned" so the
                                                            // host gets a Try-Again CTA instead of the generic empty-state
                                                            // copy that hides the real cause. Retries the catalog (CMS)
                                                            // and the user's library together.
                                                            <Row className="text-center justify-content-center text-white">
                                                                <h3 className="mb-0">We couldn't load your games</h3>
                                                                <h5 className="mb-4"><strong>This is usually a network blip - give it another try.</strong></h5>

                                                                <button
                                                                    className={`${styles.button} ${styles.small}`}
                                                                    style={{ width: "fit-content" }}
                                                                    onClick={this.retryGameFetches}
                                                                >
                                                                    Try again
                                                                </button>

                                                                <h4 className="mt-4 mb-0">Still not loading?</h4>
                                                                <h6 className="mb-0"><strong>Try refreshing the page, or get in touch at: <a style={{ color: "white" }} href="mailto:info@thegamescollective.com">info@thegamescollective.com</a></strong></h6>
                                                            </Row>
                                                            : (this.state.userGames.length === 0 && this.state.freeGames.length === 0) ?
                                                            <Row className="text-center justify-content-center text-white">
                                                                <h3 className="mb-0">Looks like you don't have any games yet!</h3>
                                                                <h5 className="mb-5"><strong>You can buy your first game below…</strong></h5>


                                                                <h4 className="mt-4 mb-0">Think you should have some games?</h4>
                                                                <h6 className="mb-1"><strong>Click below to refresh!</strong></h6>
                                                                <button
                                                                    className={`${styles.button} ${styles.small}`}
                                                                    style={{ width: "fit-content" }}
                                                                    onClick={() => window.location.reload()}
                                                                >
                                                                    Refresh Page
                                                                </button>

                                                                <h4 className="mt-4 mb-0">Still having issues?</h4>
                                                                <h6 className="mb-0"><strong>Check you're logged into the correct account.</strong></h6>
                                                                <h6><strong>If you are, get in touch at: <a style={{ color: "white" }} href="mailto:info@thegamescollective.com">info@thegamescollective.com</a></strong></h6>
                                                            </Row>
                                                            :
                                                            <>
                                                                <h2 className={`text-center ${styles.lobbyTitle}`}>Select A Game</h2>
                                                                {this.getOwnedGames()}
                                                            </>
                                                        }

                                                        {(() => {
                                                            const unowned = [
                                                                ...this.getUnownedProducts(),
                                                                ...this.getUnownedAddonsForOwnedGames().map(enrichAddonWithParentMeta)
                                                            ];
                                                            if (unowned.length === 0) return null;
                                                            return <>
                                                                <h2 className={styles.separator}>Add More</h2>
                                                                <ul className={styles.games}>
                                                                    {unowned.map(p => <li className={styles.game} key={p.gameId}><Game game={p} showAddToCart={true} showBuyNow={true} smallCartButton={true} onBuyNow={this.onBuyGameForLobby} onClickOverride={p.type === 'Addon' ? this.onClickAddonInLobby : undefined} /></li>)}
                                                                </ul>
                                                            </>;
                                                        })()}
                                                    </>
                                                )}
                                            </Container>
                                    }
                                </React.Fragment>
                                :
                                this.state.roomError ?
                                    (() => {
                                        const isMirrorUrl = new URLSearchParams(window.location.search).has("mirror");
                                        const terminal = isTerminalRoomError(this.props.room.errorCode);
                                        return (
                                            <div className={styles.pageProblem} >
                                                <h2>
                                                    {this.state.errorMessage || this.getUserFriendlyRoomError()}
                                                    {!terminal && <><br /> Click below to rejoin!</>}
                                                </h2>
                                                {terminal ? (
                                                    // Host explicitly cut this session for this client — same-code
                                                    // retry will just fail again. Send them back to enter a fresh
                                                    // code (mirror) or back home (host attempt).
                                                    isMirrorUrl ? (
                                                        <button className={styles.button} onClick={() => this.props.navigate("/connect")}>Back to Connect</button>
                                                    ) : (
                                                        <button className={styles.button} onClick={() => this.props.navigate("/")}>Back home</button>
                                                    )
                                                ) : (
                                                    isMirrorUrl ? (
                                                        <button className={styles.button} onClick={() => this.doMirrorJoin(new URLSearchParams(window.location.search).get("mirror"))}>Retry Connect</button>
                                                    ) : (
                                                        <button className={styles.button} onClick={() => this.doCreate()}>Retry</button>
                                                    )
                                                )}
                                            </div>
                                        );
                                    })()
                                    :
                                    <div className={styles.loadingBox}>
                                        <h2>{this.state.roomLoadingTitle}</h2>
                                        <DotLoader size="large" variant="light" />
                                    </div>
                        }

                    </div>

                </div>
                {!this.state.acceptedScreenSizeWarning && <ErrorModal
                    title={"Screen Size Warning"}
                    styles={`${styles.screenModel} d-flex`}
                    message={"Your screen looks too small to host Game City... Please try hosting on a larger screen, like a tablet, TV or laptop and ensure it has an aspect ratio of 4:3 or wider. If you still wish to continue you will likely encounter visual issues!"}
                    callback={this.closeAndLeave}
                    callbackText={"Back"}
                    callback2={this.acceptSmallScreen}
                    callbackText2={"Continue"}
                />}
                {/*<div className={`${styles.screenOverlay} d-flex d-sm-flex d-md-none`} >*/}
                {/*    <div className={styles.screenOverlayBG}></div>*/}
                {/*    <FormPage modal={true}>*/}
                {/*        <h2 className={formStyles.formTitle}>Screen Size Warning</h2>*/}
                {/*        <p>Your screen looks too small to host Game City... Please try hosting on a larger screen, like a tablet, TV or laptop.</p>*/}
                {/*        <button onClick={() => this.closeAndLeave()} className={`${styles.button} ${styles.alternate}`}>Back</button>*/}
                {/*    </FormPage>*/}
                {/*</div>*/}

                {
                    this.state.selectedGame &&
                    <GameMenu game={this.state.selectedGame} closeGameMenu={this.closeGameMenu} supported={true} />
                }
                {this.state.BuyForLobbyGame &&
                    <BuyForLobbyModal
                        game={this.state.BuyForLobbyGame}
                        hostUser={this.props.auth.user}
                        onPurchased={this.onPurchased}
                        onClose={() => { this.setState({ BuyForLobbyGame: null }); }}
                    />
                }
            </React.Fragment>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        room: state.room,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        createRoom: (token, userId, isRoku, QRSessionID, roomCode, externalGameToken) => {
            return dispatch(createRoom(token, userId, APP_TYPES.WEB, isRoku, QRSessionID, roomCode, externalGameToken))
        },
        reconnectToRoom: (token) => {
            return dispatch(reconnectToRoom(token))
        },
        joinAsMirror: (roomId) => {
            return dispatch(joinAsMirror(roomId))
        },
        reconnectAsMirror: (token) => {
            return dispatch(reconnectAsMirror(token))
        },
        sessionEnded: (message) => {
            return dispatch(sessionEnded(message))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Lobby));
